import { CSSProperties } from 'react'

import { IPoapStatusTypeIndicatorProps, RedeemCodePoapMintStatusesE } from 'primsell-shared-layer/types'

import * as S from './poap-status-type-indicator.styles'

const POAP_STATUS_TYPE_BORDER_COLOR: Record<RedeemCodePoapMintStatusesE, CSSProperties['borderColor']> = {
  [RedeemCodePoapMintStatusesE.COMPLETED]: '#8968F5',
  [RedeemCodePoapMintStatusesE.PENDING]: '#0E9F6E',
  [RedeemCodePoapMintStatusesE.FAILED]: '#8968F5',
}
const POAP_STATUS_TYPE_BACKGROUND_COLOR: Record<RedeemCodePoapMintStatusesE, CSSProperties['backgroundColor']> = {
  [RedeemCodePoapMintStatusesE.COMPLETED]: '#8968F5',
  [RedeemCodePoapMintStatusesE.PENDING]: '#0E9F6E',
  [RedeemCodePoapMintStatusesE.FAILED]: '#8968F54D',
}

const POAP_STATUS_TYPE_TEXT_COLOR: Record<RedeemCodePoapMintStatusesE, CSSProperties['color']> = {
  [RedeemCodePoapMintStatusesE.COMPLETED]: '#FFF',
  [RedeemCodePoapMintStatusesE.PENDING]: '#FFF',
  [RedeemCodePoapMintStatusesE.FAILED]: '#7859DB',
}

const POAP_STATUS_TYPE_TEXT: Record<RedeemCodePoapMintStatusesE, string> = {
  [RedeemCodePoapMintStatusesE.COMPLETED]: 'Completed',
  [RedeemCodePoapMintStatusesE.PENDING]: 'Pending',
  [RedeemCodePoapMintStatusesE.FAILED]: 'Failed',
}

export const PoapStatusTypeIndicator = ({ type }: IPoapStatusTypeIndicatorProps) => {
  if (!type) {
    return <S.TypeText textcolor="#000">-</S.TypeText>
  }

  return (
    <S.PoapStatusContainer
      backgroundColor={POAP_STATUS_TYPE_BACKGROUND_COLOR[type]}
      borderColor={POAP_STATUS_TYPE_BORDER_COLOR[type]}
    >
      <S.TypeText textcolor={POAP_STATUS_TYPE_TEXT_COLOR[type]}>{POAP_STATUS_TYPE_TEXT[type]}</S.TypeText>
    </S.PoapStatusContainer>
  )
}
